import { Component, Injector, OnInit } from '@angular/core';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import {
  UserFavoriteMenuItemBean,
  UserFavoriteMenuResp,
} from 'src/app/core/models/menu/user-favorite-menu-resp';
import { MenuService } from 'src/app/core/services/menu.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';

@Component({
  selector: 'laas-user-favorite-menu',
  templateUrl: './user-favorite-menu.component.html',
  styleUrl: './user-favorite-menu.component.scss',
})
export class UserFavoriteMenuComponent
  extends SessionBaseComponent
  implements OnInit
{
  userFavoriteMenus: UserFavoriteMenuResp[] = [];
  userUuid: string;

  constructor(injector: Injector, private menuService: MenuService) {
    super(injector);
    this.userUuid = '';
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.userUuid = this.userProfile?.uuid;
    this.searchAllMenusList();
  }

  searchAllMenusList(): void {
    this.menuService.getAllAuthorizedMenu(this.userUuid).subscribe({
      next: (resp) => {
        resp.forEach((x) => {
          setTimeout(() => {
            x.parentMenu.label = this.getMenuLabelByLanguage(x.parentMenu);
            if (x.parentMenu.icon) {
              x.parentMenu.icon =
                GlobalConstants.menuIconMap.get(x.parentMenu.icon) ?? '';
            }
            x.subMenuList.forEach((sub) => {
              sub.label = this.getMenuLabelByLanguage(sub);
              if (sub.icon) {
                sub.icon =
                  GlobalConstants.menuIconMap.get(sub.icon) ?? '';
              }
            }, 0);
          });
        });
        this.userFavoriteMenus = resp;
      },
      error: (err) => {
        this.toastErrorMessage(err.error.errorMsg);
      },
    });
  }

  getMenuLabelByLanguage(menu: UserFavoriteMenuItemBean): string {
    if (!menu) return '';
    const normalizedLang = this.laasSetting.language?.toLowerCase();
    switch (normalizedLang) {
      case 'en-us':
        return menu.nodeNameEN || '';
      case 'zh-tw':
        return menu.nodeNameTW || '';
      default:
        return '';
    }
  }

  toggleCategoryFavorite(menuResp: UserFavoriteMenuResp): void {
    const menuSeqList = menuResp.subMenuList.map((p) => p.menuSeqNo);
    menuResp.parentMenu.animate = true;
    const request = {
      uuid: this.userUuid,
      menuSeqList: menuSeqList,
    };
    const isFavorite = !menuResp.parentMenu.favorite;
    if (isFavorite) {
      this.menuService.addFavoriteMenu(request).subscribe({
        next: () => {
          this.searchAllMenusList();
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error.errorMsg);
        },
      });
    } else {
      this.menuService.deleteFavoriteMenu(request).subscribe({
        next: () => {
          this.searchAllMenusList();
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error.errorMsg);
        },
      });
    }
    setTimeout(() => {
      menuResp.parentMenu.animate = false;
    }, 400);
  }

  toggleSubMenuFavorite(subMenu: UserFavoriteMenuItemBean): void {
    subMenu.animate = true;
    const request = {
      uuid: this.userUuid,
      menuSeqList: [subMenu.menuSeqNo],
    };

    if (!subMenu.favorite) {
      this.menuService.addFavoriteMenu(request).subscribe({
        next: () => {
          subMenu.favorite = !subMenu.favorite;
        },
        error: (err: any) => {
          this.toastErrorMessage(err);
        },
      });
    } else {
      this.menuService.deleteFavoriteMenu(request).subscribe({
        next: () => {
          subMenu.favorite = !subMenu.favorite;
        },
        error: (err: any) => {
          this.toastErrorMessage(err);
        },
      });
    }

    setTimeout(() => {
      subMenu.animate = false;
    }, 400);
  }

  isInternalRoute(url?: string): boolean {
    return !!url && url.startsWith('/');
  }
}
